import { ApolloError } from "@apollo/client";

/**
 * Apollo Client 에러 객체인지 확인합니다.
 */
const isApolloError = (error: unknown): error is ApolloError => {
  return (
    typeof error === "object" &&
    error !== null &&
    "graphQLErrors" in error &&
    "networkError" in error
  );
};

/**
 * 에러 객체에서 사용자에게 표시할 메시지를 추출합니다.
 * ApolloError의 GraphQL 에러 > 네트워크 에러 > 일반 Error > 기본 메시지 순으로 처리합니다.
 */
export const getErrorMessage = (
  error: ApolloError | Error | unknown
): string => {
  if (isApolloError(error)) {
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      return error.graphQLErrors[0].message || "오류가 발생했습니다.";
    }
    if (error.networkError) {
      return error.networkError.message || "네트워크 오류가 발생했습니다.";
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }

  return "오류가 발생했습니다. 다시 시도해주세요.";
};
